import styled from 'styled-components'
import {
  COLOR,
  Z_INDEXS,
} from '../../themes'
const Style = styled.div`
  width: 100%;
  box-shadow: 0px 4px 6px 1px ${COLOR.GRAY_5};
  position: absolute;
  background: white;
  z-index: ${Z_INDEXS.LV_1};
  margin: 0;
  margin-bottom: 32px;
  cursor: pointer;
  overflow: scroll;
  max-height: 172px;

  * {
    cursor: pointer;
  }
  .search-container {
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .badge-container {
    border-color: transparent;
    transition: 50ms ease-out;
  }
  .badge-container:hover {
    background-color: ${COLOR.GOLD_1};
    border-color: ${COLOR.GOLD_1};
  }
  .badge-container:focus {

  }
  .badge-container:active {
    background-color: ${COLOR.GOLD_1};
    border-color: ${COLOR.GOLD_1};
  }
  .badge-container:active h1 {
    color: white;
  }
  .badge-container:active label {
    color: ${COLOR.Sky_1};
  }
  .badge-container:active figure {
    border-color: white;
  }
  .search-container:active .badge-container:hover:not(:active) {
    border-color: transparent;
    background-color: transparent;
  }
  .empty{
    color: ${COLOR.GRAY_3};
    width: 100%;
    line-height: 36px;
    height: 36px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
    cursor: auto;
  }
`

export default Style
